import { render } from "./PhonenumberInput.vue?vue&type=template&id=319f8482"
import script from "./PhonenumberInput.vue?vue&type=script&lang=js"
export * from "./PhonenumberInput.vue?vue&type=script&lang=js"

import "./PhonenumberInput.vue?vue&type=style&index=0&id=319f8482&lang=css"
script.render = render

export default script